// Wishlist simple con localStorage (sin cuenta de cliente). Guarda un array
// de IDs de producto en el navegador; se pierde si el cliente limpia datos
// del navegador o cambia de dispositivo -- alcance acordado con el usuario.
(function () {
  var STORAGE_KEY = 'rechilero_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(ids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }

  function updateButton(button, saved) {
    var label = button.querySelector('[data-wishlist-label]');
    if (label) {
      label.textContent = saved ? 'Quitar de lista de deseos' : 'Guardar en lista de deseos';
    }
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.classList.toggle('rechilero-wishlist-btn--active', saved);
  }

  function init() {
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    var wishlist = getWishlist();

    buttons.forEach(function (button) {
      var productId = button.getAttribute('data-product-id');
      updateButton(button, wishlist.indexOf(productId) !== -1);

      button.addEventListener('click', function () {
        var ids = getWishlist();
        var index = ids.indexOf(productId);
        if (index === -1) {
          ids.push(productId);
        } else {
          ids.splice(index, 1);
        }
        setWishlist(ids);
        updateButton(button, index === -1);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
